import { useMemo } from "react";
import { SocraticDialogueFragment } from "@/generated/graphql";

export function getLatestDialogue(
  dialogues: readonly SocraticDialogueFragment[]
): SocraticDialogueFragment | null {
  if (dialogues.length === 0) return null;
  return dialogues.reduce((latest, current) =>
    current.attemptNumber > latest.attemptNumber ? current : latest
  );
}

export function useLatestDialogue(dialogues: readonly SocraticDialogueFragment[]) {
  return useMemo(() => getLatestDialogue(dialogues), [dialogues]);
}